/**
 * Platform wrapper for @sentry/react. The CoP routes major-churn deps through
 * `@platform/*` wrappers so the next Sentry major touches this file only —
 * app code must not import '@sentry/react' directly.
 */
import * as Sentry from '@sentry/react';
import { config } from '@config';

export function initSentry(): void {
  if (!config.sentryDsn) return;
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.env,
    release: config.gitSha,
  });
}

export function captureError(error: unknown): void {
  if (!config.sentryDsn) return;
  Sentry.captureException(error);
}
